import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.68721 10.7144C5.84363 10.8718 6.09831 10.8718 6.25472 10.7144L8.5 8.45455L10.7453 10.7144C10.9017 10.8718 11.1564 10.8718 11.3128 10.7144L11.7174 10.3072C11.8734 10.1502 11.8722 9.8964 11.7149 9.74081L9.44839 7.5L11.6747 5.2592C11.8297 5.1032 11.8297 4.85134 11.6747 4.69535L11.2702 4.28818C11.1128 4.12975 10.8561 4.13091 10.7002 4.29075L8.5 6.54545L6.25472 4.2856C6.09831 4.12817 5.84363 4.12817 5.68721 4.2856L5.28262 4.69282C5.12665 4.8498 5.12778 5.1036 5.28515 5.25919L7.55161 7.5L5.28515 9.74081C5.12778 9.8964 5.12665 10.1502 5.28262 10.3072L5.68721 10.7144Z",
		fill: "#2C3F81"
	})
});
export default SvgCloseIcon;
